import {useMapContext} from '@/components/MindMap/index.mjs'
import ModulePropertiesPane from '../_MODULE/ModulePropertiesPane.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Model from './ModelUm.mjs'
import Ui from './PropertiesControllerUi.jsx'
import Uv from './PropertiesControllerUv.jsx'

export default function PropertiesPaneUm(props) {
    const map = useMapContext()
    const [node] = map.useSelectedNodes()

    return (
        <ModulePropertiesPane
            controllers={
                <>
                    <Text prop="umUserCode" />
                    <Text prop="umName" />

                    {
                        ! node.firstChild &&
                        <>
                            <Ui label="入口界面" />
                            <Uv label="入口视图" />
                        </>
                    }
                </>
            }

            Model={Model}

            snSuffix={
                <Analyse
                    modes={[
                        'Reference',
                        'ReferenceCall',
                        'IsrfReference',
                    ]}
                />
            }

            versionLabel="界面地图版本号"
            {...props}
        />
    )
}
